import React from "react";
import Success from "../../../assets/assets/nip-approved.svg";
import { PropTypes } from "prop-types";
import Rodal from "rodal";

const ContinueSuccessModal = ({ hide, visible }) => {
  return (
    <Rodal width={Number("520")} height={Number("480")} visible={visible}>
      <div className="success-modal-body">
        <div className="modal-image">
          <img src={Success} alt="icon" />
        </div>
        <h3>Outward Test Completed</h3>
        <p>
          Outward test has been completed. Please move on to <br /> Inward test
        </p>
        <div className="modal-btn">
          <button onClick={() => hide()} data-testid="hideModal">
            continue
          </button>
        </div>
      </div>
    </Rodal>
  );
};

ContinueSuccessModal.propTypes = {
  hide: PropTypes.func,
  visible: PropTypes.any,
};

export default ContinueSuccessModal;
